export default {
  mounted() {
    if (this.renderMode === 'edit') {
      this.contentData = Object.assign({}, this.contentValue);
    }
  },

  computed: {
    isViewMode() {
      return this.renderMode === 'view';
    },
    isEditMode() {
      return this.renderMode === 'edit';
    },
    isCreateMode() {
      return this.renderMode === 'create';
    }
  },

  data: () => ({
    contentData: {}
  }),

  methods: {
    getRenderOption(key, defaultValue) {
      const renderOptions = this.options.renderOptions ? this.options.renderOptions : {};

      return _.get(renderOptions, key, defaultValue);
    }
  },

  props: {
    contentValue: {
      type: Object
    },

    metadata: {
      type: Object,
      default () {
        return null;
      }
    },

    renderMode: {
      type: String,
      default: 'view',
      validator(value) {
        return ['view', 'edit', 'create'].indexOf(value) !== -1;
      }
    },

    options: {
      type: Object,
      default: () => ({})
    }
  },

  watch: {
    contentData: {
      handler(newValue, oldValue) {
        this.$emit('update-value', newValue);
      },
      deep: true
    }
  }
};
